{
	"ID": 5,
	"fields": {
		"isGUID": true,
		"isAgentNumber": true,
		"isPartition": true,
		"isDescription": true,
		"advanced": {
			"isCallCentreLicenceType": false,
			"isInternalNumber": false,
			"isCiscoCommonID": false,
			"isOverrideMonitoring": false,
			"isWebexCallingUserID": false,
			"isBroadworksUserID": false,
			"isOwningGroupID": false,
			"isOidOnTelServer": true,
			"isOwningDepartment": true,
			"isTeamsUserID": false,
			"isUserPrincipalName": false
		},
		"omnichannel": {
			"isAllowAnsweringConcurrentChannels": true,
			"chatIntegration": {
				"isType": true,
				"isId": true
			},
			"emailIntegration": {
				"isType": true,
				"isEmailAddress": true,
				"isId": true
			}
		},
		"isUpdateDuplicateItems": true
	}
}